import React from "react";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const DownloadWithEmailButton = ({
  colorTheme,
  collectEmailModal
}: {
  colorTheme: string;
  collectEmailModal: Function;
}) => {
  return (
    <div
      className="btn-add-cart geo-btn--caps"
      onClick={e => {
        e.preventDefault();
        collectEmailModal();
      }}
      style={{
        background: ContrastForegroundUtility.lbFgColor(colorTheme),
        borderColor: ContrastForegroundUtility.lbFgColor(colorTheme),
        color: "white"
      }}
    >
      <span
        className="fa fa-download"
        style={{ color: "white", marginRight: 8 }}
      />
      <span>Download now</span>
    </div>
  );
};

export default DownloadWithEmailButton;
